<template>
    <div class="div-half">
        <button class="btn btn-sm btn-grey" @click.prevent="trigger">
            <slot></slot>
        </button>
        <guest-or-account-modal
            :show="showRegisterModal"
            :showRegister="true"
            @guest="reset"
            @loggedin="showSaveModal"
            @close="reset"
            :checkout="false"
        ></guest-or-account-modal>
        <modal-dialog title="Save Basket" :show="showModal" @close="reset">
            <div class="form-group">
                <label>Basket Name</label>
                <input class="form-control" v-model="name">
                <div class="text-danger" v-if="error">
                    {{ error }}
                </div>
            </div>
            <button class="btn btn-sm btn-green" @click="save">Save Basket</button>
        </modal-dialog>
    </div>
</template>

<script>
    import Basket from '../../Services/Basket.js';
    import ModalDialog from '../Elements/ModalDialog.vue';
    import Notification from '../../Services/Notification.js';
    import GuestOrAccountModal from '../Elements/Modals/GuestOrAccountModal.vue';

    export default {
        components: {
            ModalDialog,
            Notification,
            GuestOrAccountModal
        },
        props: {
            guest: {
                default: true
            }
        },
        data() {
            return {
                showModal: false,
                showRegisterModal: false,
                isGuest: false,
                name: '',
                error: null
            }
        },
        mounted() {
            this.isGuest = this.guest;
        },
        methods: {
            trigger() {
                if (!this.isGuest) {
                    this.showModal = true;
                } else {
                    this.showRegisterModal = true;
                }
            },
            reset() {
                this.showModal = false;
                this.showRegisterModal = false;
            },
            showSaveModal() {
                this.isGuest = false;
                this.showRegisterModal = false;
                this.showModal = true;
            },
            save() {
                Basket.save(this.name).then(response => {
                    this.name = null;
                    this.showModal = false;
                    this.$notify({
                        text: 'Basket saved',
                        type: 'success'
                    });
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/SaveBasket.vue